import { CdkMenuItem } from '@angular/cdk/menu';
import { Component, input, output } from '@angular/core';
import {
  ButtonDirective,
  CuiDropdownComponent,
  CuiDropdownTriggerDirective,
} from '@innersource/common-ui-components';
import { formatDateTime } from '../../utils/helper';
import { ChatSession } from '../chat.model';

/** Shows the current conversation and its layout and session actions. */
@Component({
  selector: 'app-chat-header',
  imports: [ButtonDirective, CdkMenuItem, CuiDropdownComponent, CuiDropdownTriggerDirective],
  templateUrl: './chat-header.component.html',
  styleUrl: './chat-header.component.scss',
  host: { '[class.chat-header--fullscreen]': 'fullscreen()' },
})
export class ChatHeaderComponent {
  /** Inputs. */
  readonly session = input<ChatSession | null>(null);
  readonly fullscreen = input(false);

  /** Outputs. */
  readonly showOverview = output<void>();
  readonly newChat = output<void>();
  readonly deleteSession = output<ChatSession>();
  readonly enterFullscreen = output<void>();

  /** Template Forwards. */
  readonly formatDateTime = formatDateTime;
}
